export const labels = {
  'FIRST NAME': 'FIRST NAME',
  'LAST NAME': 'LAST NAME',
  Gender: 'Gender',
  Age: 'Age',
  'Country Of Residence': 'Country Of Residence',
  EDUCATION: 'EDUCATION',
  'FIRST PRIORITY': 'FIRST PRIORITY',
  'SECOND PRIORITY': 'SECOND PRIORITY',
  'THIRD PRIORITY': 'THIRD PRIORITY',
  COMPANY: 'COMPANY',
  EMAIL: 'EMAIL',
  PASSWORD: 'PASSWORD',
  'CONFIRM PASSWORD': 'CONFIRM PASSWORD',
  'ROLE AT Organization': 'ROLE AT Organization',
  'ORGANIZATION TYPE': 'ORGANIZATION TYPE',
  'NUMBER OF PEOPLE': 'NUMBER OF PEOPLE',
  'INVESTMENT STAGE': 'INVESTMENT STAGE',
  'VIRTUAL WORKERS': '% OF VIRTUAL WORKERS',
  'CURRENT STATUS': 'CURRENT STATUS',
  'PREFERRED LANGUAGE': 'PREFERRED LANGUAGE',
  ETHNICITY: 'ETHNICITY / RACE',
  'Current Password': 'Current Password',
  Password: 'Password',
  'Confirm password': 'Confirm password',
  'Organization name': 'Organization name',
  TEAM: 'TEAM',
  'NEW PASSWORD': 'NEW PASSWORD',
  'CONFIRM NEW PASSWORD': 'CONFIRM NEW PASSWORD',
  Title: 'Title',
  'Card Number': 'Card Number',
  'Expiration Date': 'Expiration Date',
  CVV: 'CVV',
  SUBJECT: 'SUBJECT',
  BODY: 'MESSAGE',
  BillerName: 'Biller Name',
  FullName: 'Full Name',
  AddressLine1: 'Address Line 1',
  AddressLine2: 'Address Line 2',
  Country: 'Country',
  PostalCode: 'Postal Code',
  State: 'State',
  City: 'City',
  QuestState: 'State / Province / Region',
  QuestPostalCode: 'Postal Code / Zip Code',
}

export const getAddressFieldLabel = (field) => {
  switch (field) {
    case 'Address':
      return 'Address'
    case 'Address2':
      return labels.AddressLine2
    case 'City':
      return 'City/Town'
    case 'State':
      return labels.QuestState
    case 'Zip':
      return labels.QuestPostalCode
    case 'Country':
      return labels.Country
    default:
      return null
  }
}
export const placeholders = {
  Email: 'Email',
  Password: 'Password',
  'Remember Me': 'Remember Me',
  'First Name': 'First Name',
  'Last Name': 'Last Name',
  'Select if you are currently in a career transition':
    'Select if you are currently in a career transition',
  'Confirm password': 'Confirm password',
  Company: 'Company',
  Team: 'Team',
  Language: 'Language',
  Name: 'Name',
  Message: 'Message',
  'New Password': 'New Password',
  'Confirm New Password': 'Confirm New Password',
  Age: 'Age',
  Select: 'Select',
  'Select One': 'Select One',
  'Virtual Workers': 'Virtual Workers',
  'Current Password': 'Current Password',
  'Email Here': 'Email Here',
  'Eight Zeros': '0000 0000 0000 0000',
  MM: 'MM',
  YY: 'YY',
  '000': '000',
  Organization: 'Organization',
  Title: 'Title',
  'Have a Promo Code?': 'Have a Promo Code?',
  Loading: 'Loading...',
  // BillerName: 'Biller Name',
  // AddressLine1: 'Enter Address Line 1',
  // AddressLine2: 'Enter Address Line 2',
  // Country: 'Enter Country',
  // State: 'Enter State',
  // PostalCode: 'Enter Postal Code',
  // City: 'Enter City',
}
